import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { OverlayTrigger, Tooltip, Button, Modal } from "react-bootstrap";
import { TrashFill } from "react-bootstrap-icons";
import SVG from "react-inlinesvg";
import useRazorpay from "react-razorpay";
import { post } from "../../components/api";
import ModalPopup from "../../components/ModalPopup";
import Basic from "../../assets/images/plans/Basic.svg";
import Premium from "../../assets/images/plans/Premium.svg";
import Standard from "../../assets/images/plans/Standard.svg";
import ArrowRight from "../../assets/images/plans/ArrowRight.svg";
import { SweetAlert, showConfirmDialog } from "../../helpers/helper";
import rtoArrayList from "../../assets/rtoList";
import Translate from "../../components/Translate";

// vehicle add validation
const validationSchema = Yup.object().shape({
  vehiclesData: Yup.array().of(
    Yup.object().shape({
      vehicleNo: Yup.string()
        .required("Vehicle no is required")
        .matches(
          /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/,
          "Please enter a valid vehicle number format."
        )
        .test("match-rtostatelist", "No such state code found", (value) => {
          if (value) {
            return rtoArrayList.some((item) => item === value.substring(0, 4));
          } else {
            return true;
          }
        }),
    })
  ),
});

const BuyGps = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const { type } = location.state || {};
  const initialValues = {
    vehiclesData: [
      {
        vehicleNo: "",
      },
    ],
  };
  const [Razorpay] = useRazorpay();
  const [selectedPlan, setSelectedPlan] = useState("");
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [plans, setPlans] = useState([]);
  const [planType, setPlanType] = useState("GPS");
  const [showStopModal, setShowStopModal] = useState(false);

  useEffect(() => {
    setPlanType(type ? type : "GPS");
  }, [type]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await post("/admin/get-planlist", {
          planType: planType,
        });
        if (response.status == 200) {
          const sortedPlans = response.data.sort((a, b) => b.year - a.year);
          setPlans(sortedPlans);
        } else {
          setPlans([]);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [planType]);

  // form
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      let jsonData = {
        planId: selectedPlan,
        vehicles: values.vehiclesData,
      };
      handlePayment(jsonData);
    },
  });

  // show modal
  // const handleShowModal = (planId) => {
  //   setSelectedPlan(planId);
  //   setShowVehicleModal(true);
  // };

  // close modal
  const handleCloseModal = () => {
    setSelectedPlan("");
    const clearedVehiclesData = initialValues.vehiclesData.map(() => ({
      vehicleNo: "", // Reset each vehicleNo to empty string
    }));
    formik.setValues({ ...formik.values, vehiclesData: clearedVehiclesData });
    setShowVehicleModal(false);
  };

  const openDeleteDialog = async (id) => {
    const confirmed = await showConfirmDialog(
      "Delete!",
      "Are you sure you want to delete vehicle?"
    );
    if (confirmed) {
      let contentArray = formik.values.vehiclesData;
      contentArray.splice(id, 1);
      formik.setFieldValue("vehiclesData", contentArray);
    }
  };

  // Razor pay payment
  const handlePayment = async (params) => {
    try {
      // Create order on your backend and retrieve the order details
      const order = await createOrder(params);
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY, // Your Razorpay Key ID
        amount: order.amount, // Order amount in paise (e.g., 50000 for ₹500.00)
        currency: order.currency,
        name: "FleetStakes Pvt.LTD",
        description: "Test Transaction",
        image:
          "http://localhost:3000/static/media/logo.91ed4b160f822935a22b.png",
        order_id: order.orderId, // Pass the order ID obtained from your backend
        prefill: {
          name: "Sedhal Soni",
          email: "test@example.com",
          contact: "8980782616",
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#3399cc",
        },
        handler: function (response) {
          // Handle successful payment
          console.log(response.razorpay_order_id);
          setTimeout(() => {
            navigate("/orders");
          }, 2000);
        },
        modal: {
          ondismiss: function () {
            // Handle the case when the user closes the payment modal without completing the payment
            console.log("Payment modal has been dismissed");
          },
        },
      };
      const rzp1 = new Razorpay(options);
      rzp1.open();
    } catch (error) {
      console.error("Error processing payment:", error);
    }
  };

  async function createOrder(params) {
    const response = await post("/admin/create-order", params);
    if (response.status == 200) {
      return response.data;
    } else {
      SweetAlert(response.message, true);
    }
  }

  return (
    <div className="h-100">
      <div>
        <h5 className={`page-title text-left`}>GPS Plans</h5>
      </div>
      <div className="row d-flex justify-content-center align-items-center">
        {plans.length > 0 &&
          plans.map((plan, pIndex) => {
            return (
              <div
                className="col-md-4 col-lg-4 col-xs-12 mb-4 mb-md-0 mb-lg-0"
                key={`plan-${pIndex}`}
              >
                <div className="card plan-card">
                  <div className="card-body">
                    <div className="mb-5">
                      <SVG
                        src={
                          pIndex == 0 ? Basic : pIndex == 1 ? Standard : Premium
                        }
                        className="main-icon"
                        alt=""
                        width={"40px"}
                        height={"40px"}
                      />
                      <h6 className="plan-title mt-3">{plan.name}</h6>
                      <p className="plan-desc mt-3">
                        <Translate>buyNewGpsMessage</Translate>
                      </p>
                      <p className="plan-price mb-1">{`₹${plan.discountedPrice}`}</p>
                      <p className="plan-year">
                        ₹{plan.perMonth} / <Translate>perMonth</Translate>
                      </p>
                      <div className="d-flex justify-content-center">
                        <Button
                          variant="btn btn-outline-primary custom-btn d-flex align-items-center justify-content-evenly"
                          onClick={() => setShowStopModal(true)}
                        >
                          <Translate>getStarted</Translate>{" "}
                          <SVG src={ArrowRight} />{" "}
                        </Button>{" "}
                      </div>
                    </div>
                    {/* <hr />
                    <div className="d-flex flex-column align-items-start mt-4 plan-detail-text">
                      {plan.details.length > 0 &&
                        plan.details.map((detail, i) => (
                          <div className="d-flex justify-content-center align-items-center mt-1" key={`detail-${i}`}>
                            <SVG
                              src={CheckCircle}
                              alt=""
                              width={"25px"}
                              height={"25px"}
                            />
                            <p className="mb-1 ml-2 plan-details">{detail}</p>
                          </div>
                        ))}
                    </div> */}
                  </div>
                </div>
              </div>
            );
          })}
        {showStopModal && (
          <Modal
            show={showStopModal}
            onHide={() => setShowStopModal(false)}
            // aria-labelledby="contained-modal-title-vcenter"
            className="add-vehicle-modal"
          >
            <Modal.Body>
              <p>
                <b>
                  Online payment through the application is currently
                  unavailable.
                </b>
                <br />
                To proceed with your purchase, please contact us at <br />
                <b>+91 88664 72223</b>.
              </p>{" "}
              <div className="d-flex align-items-center justify-content-end">
                <Button
                  variant="d-flex align-items-center justify-content-evenly"
                  onClick={() => setShowStopModal(false)}
                  style={{
                    marginTop: "10px",
                    border: "1px solid green",
                    borderRadius: "5px",
                  }}
                >
                  OK
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        )}
        {showVehicleModal && formik && (
          <ModalPopup
            className="add-vehicle-modal"
            show={showVehicleModal}
            onHide={handleCloseModal}
            title={<Translate>addVehicle</Translate>}
          >
            <form onSubmit={formik.handleSubmit}>
              {formik.values.vehiclesData &&
                formik.values.vehiclesData.length > 0 &&
                formik.values.vehiclesData.map((vehicle, index) => (
                  <div className="row" key={`vehicle-${index}`}>
                    <div className="col-md-12 d-flex justify-content-between align-items-center">
                      <label
                        htmlFor={`vehiclesData.${index}.vehicleNo`}
                        className="required custom-form-label"
                      >
                        <Translate>vehicle</Translate> {index + 1}
                      </label>
                      {formik.values.vehiclesData.length > 1 && (
                        <OverlayTrigger
                          overlay={
                            <Tooltip id={`products-delete-tooltip-${index}`}>
                              Delete
                            </Tooltip>
                          }
                        >
                          <a
                            className="btn btn-icon delete-btn btn-hover-danger btn-sm"
                            onClick={() => {
                              openDeleteDialog(index);
                            }}
                          >
                            <TrashFill size={16} />
                          </a>
                        </OverlayTrigger>
                      )}
                    </div>
                    <div className="col-md-12 mb-7">
                      <input
                        type="text"
                        id={`vehiclesData.${index}.vehicleNo`}
                        name={`vehiclesData.${index}.vehicleNo`}
                        className="form-control form-control-solid mb-3 mb-lg-0"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={vehicle.vehicleNo} // Accessing value directly from the vehicle object
                      />
                      {formik.touched.vehiclesData &&
                        formik.touched.vehiclesData[index] &&
                        formik.errors.vehiclesData &&
                        formik.errors.vehiclesData[index] && (
                          <div>
                            <p className="mb-0 field-error">
                              {formik.errors.vehiclesData[index].vehicleNo}
                            </p>
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              <div className="d-flex justify-content-end mt-2">
                <a
                  href="#"
                  className="plan-add-vehicle"
                  onClick={(e) => {
                    e.preventDefault();
                    formik.setFieldValue("vehiclesData", [
                      ...formik.values.vehiclesData,
                      { vehicleNo: "" },
                    ]);
                  }}
                >
                  + <Translate>addVehicle</Translate>
                </a>
              </div>
              <div className="d-flex justify-content-end mt-4">
                <button type="submit" className="btn pay-now-btn">
                  <Translate>payNow</Translate>
                </button>
              </div>
            </form>
          </ModalPopup>
        )}
      </div>
    </div>
  );
};

export default BuyGps;
